import { useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import './Sidebar.css'

function Sidebar() {
  const navigate = useNavigate()

  const [isOpen, setIsOpen] = useState(false)
  const [collapsed, setCollapsed] = useState(false)

  function handleLogout() {
    localStorage.removeItem('techdelivery_token')
    navigate('/login')
  }

  function closeSidebar() {
    setIsOpen(false)
  }

  function toggleCollapsed() {
    setCollapsed(!collapsed)
  }

  return (
    <>
      <button
        className="sidebarMobileButton"
        onClick={() => setIsOpen(true)}
      >
        ☰
      </button>

      {isOpen && (
        <div
          className="sidebarOverlay"
          onClick={closeSidebar}
        />
      )}

      <aside
        className={`sidebar ${collapsed ? 'collapsed' : ''
          } ${isOpen ? 'sidebarOpen' : ''
          }`}
      >
        <div className="sidebarTop">
          <button
            className="collapseButton"
            onClick={toggleCollapsed}
          >
            ☰
          </button>

          {!collapsed && (
            <div className="sidebarLogo">
              TechDelivery
            </div>
          )}

          <button
            className="sidebarClose"
            onClick={closeSidebar}
          >
            ×
          </button>
        </div>

        <nav className="sidebarNav">
          <NavLink to="/comenzi">
            <span className="menuIcon">📦</span>
            {!collapsed && <span>Comenzi</span>}
          </NavLink>

          <NavLink to="/clienti">
            <span className="menuIcon">👥</span>
            {!collapsed && <span>Clienți</span>}
          </NavLink>

          <NavLink to="/furnizori">
            <span className="menuIcon">🏭</span>
            {!collapsed && <span>Furnizori</span>}
          </NavLink>

          <NavLink to="/produse">
            <span className="menuIcon">🔌</span>
            {/* <span className="menuIcon">🛒</span> */}
            {!collapsed && <span>Produse</span>}
          </NavLink>
        <NavLink
  to="/comanda-furnizor"
  className="supplierOrderLink"
>
  <span className="menuIcon">🛒</span>
  {!collapsed && <span>Comandă furnizor</span>}
</NavLink>
        </nav>

        <button
          className="logoutButton"
          onClick={handleLogout}
        >
          {collapsed ? '⏻' : 'Logout'}
        </button>
      </aside>
    </>
  )
}

export default Sidebar